import React from "react";
import FincludeLogo from "../../assets/images/finclude.png";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import useLogout from "../common/useLogout";
import useMobileView from "../common/useMobileView";
import LinkWithAuth from "../common/LinkWithAuth";

const Header = ({ currentUser }) => {
  const [handleBurgerButton, openMobileClass] = useMobileView("");
  const [handleLogout] = useLogout();

  return (
    <div className={openMobileClass}>
      <nav className="header-nav pl-3 pr-2 px-sm-3 px-md-4 px-lg-5 py-3 py-sm-4">
        <LinkWithAuth
          condition={["Admin", "Developer"]}
          className={"navbar-brand"}
          currentUser={currentUser}
          to={"/"}
          content={<img src={FincludeLogo} alt="Finclude" />}
        />
        <LinkWithAuth
          condition={["Admin"]}
          className="d-lg-none btn btn-sm btn-main px-2 text-xsmall ml-auto mr-1"
          currentUser={currentUser}
          to="/upgrade"
          content={"Upgrade"}
        />
        <button
          className="navbar-toggle"
          onClick={(e) => handleBurgerButton(e)}
        >
          <span className="navbar-toggle-icon" />
        </button>
        <div className="mobile-nav-menu">
          <button
            className="navbar-close"
            onClick={(e) => handleBurgerButton(e)}
          >
            <span className="navbar-close-icon" />
          </button>
          <ul className="mobile-navbar-nav ml-lg-4">
            <li className="d-lg-none">
              {currentUser.type === "Admin" ? (
                <span className="dropdown-item mt-n2">
                  <small>Current plan</small>
                  <br />
                  <strong>Free Trial</strong>
                </span>
              ) : null}
              <LinkWithAuth
                condition={["Admin"]}
                className="dropdown-item link-color text-small px-2 py-1"
                currentUser={currentUser}
                to="/upgrade"
                content={"Upgrade plan"}
              />
            </li>
            <div className="dropdown-divider d-lg-none" />
            <li className="nav-item">
              <LinkWithAuth
                condition={["Admin", "Developer"]}
                className="nav-link active"
                currentUser={currentUser}
                to="/"
                content={"Dashboard"}
              />
            </li>
            <li className="nav-item">
              <LinkWithAuth
                condition={["Admin", "Developer"]}
                className="nav-link"
                currentUser={currentUser}
                to="/applications"
                content={"Apps"}
              />
            </li>
            <li className="nav-item">
              <LinkWithAuth
                condition={["Admin"]}
                className="nav-link"
                currentUser={currentUser}
                to="/organization"
                content={"Organization"}
              />
            </li>
            <li className="nav-item">
              <LinkWithAuth
                condition={["Admin"]}
                className="nav-link"
                currentUser={currentUser}
                to="/invites"
                content={"Invite"}
              />
            </li>
          </ul>
          <ul className="mobile-navbar-nav ml-auto">
            <li className="nav-item d-none d-lg-block">
              <LinkWithAuth
                condition={["Admin"]}
                className="btn btn-sm btn-main mr-2"
                currentUser={currentUser}
                to="/upgrade"
                content={"Upgrade"}
              />
            </li>
            <li className="nav-item">
              <Link to="/support" className="nav-link">
                Support
              </Link>
            </li>
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                My account
              </a>
              <div className="dropdown-menu dropdown-menu-right">
                <span className="dropdown-item">
                  <strong>{currentUser.fullName}</strong>
                </span>
                {currentUser.type === "Admin" ? (
                  <span className="dropdown-item mt-n2">
                    <small>Current plan</small>
                    <br />
                    <strong>Free Trial</strong>
                  </span>
                ) : null}
                <LinkWithAuth
                  condition={["Admin"]}
                  className="dropdown-item link-color text-small py-1 mt-n2 d-none d-lg-block"
                  currentUser={currentUser}
                  to="/upgrade"
                  content={"Upgrade plan"}
                />
                <div className="dropdown-divider" />
                <LinkWithAuth
                  condition={["Admin", "Developer"]}
                  className="dropdown-item"
                  currentUser={currentUser}
                  to="/profile"
                  content={"Profile settings"}
                />
                {/*<a className="dropdown-item" href="billing.php">*/}
                {/*  Billing*/}
                {/*</a>*/}
                <Link
                  className="dropdown-item"
                  href="#"
                  to="/login"
                  onClick={() => handleLogout()}
                >
                  Logout
                </Link>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
};

Header.propTypes = {
  queryClient: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
};

export default Header;
